import { windowUtils } from '@packages/domain/utils/windowUtils/windowUtils';

const REFERENCE_PARAM = 'reference';
const STATUS_PARAM = 'status';

export const RedirectUrl = {
  build: function (redirectUrl, reference, status) {
    const url = new URL(redirectUrl);
    url.searchParams.append(REFERENCE_PARAM, reference);
    url.searchParams.append(STATUS_PARAM, status);

    return url.toString();
  },

  get: function () {
    const search = windowUtils.getSearch();
    const searchParams = new URLSearchParams(search);
    const redirectUrl = searchParams.get('redirect_url');
    const reference = searchParams.get('reference');
    const status = searchParams.get('status');

    if (!redirectUrl) {
      return;
    }

    const decodedRedirectUrl = decodeURIComponent(redirectUrl);

    if (!reference || !status) {
      return decodedRedirectUrl;
    }

    return this.build(decodedRedirectUrl, reference, status);
  },

  getCancellationReason: function () {
    const search = windowUtils.getSearch();
    const searchParams = new URLSearchParams(search);
    const cancellationReason = searchParams.get('cancellation_reason');
    return cancellationReason;
  },

  buildWithStatus: function (status: string) {
    const search = windowUtils.getSearch();
    const searchParams = new URLSearchParams(search);
    const redirectUrl = searchParams.get('redirect_url');

    if (!redirectUrl) {
      return;
    }

    const reference = searchParams.get('reference');
    const decodedRedirectUrl = decodeURIComponent(redirectUrl);

    if (!reference || !status) {
      return decodedRedirectUrl;
    }

    return this.build(decodedRedirectUrl, reference, status);
  },
};
